// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CHistory_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.CHistory';
  $t: string = 'SagaSchema.CHistory';

  public static GetMembers(): string[] {
    return ['ObjGuid', 'Created', 'Header', 'Text'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return CHistory_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.Created = this.Created && new Date(this.Created);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ObjGuid: Guid = GuidTools.Empty;
  public Created: Date = new Date();
  public Header: string = '';
  public Text: string = '';

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
